import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@mui/material";

const SelectField = ({
  name,
  control,
  label,
  options,
  row,
  index,
  handleChange,
  facilityDams
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return(
        <FormControl fullWidth error={fieldState.invalid}>
          <InputLabel id={`${name}-label-${index}`}>{label}</InputLabel>
          <Select
            labelId={`${name}-label-${index}`}
            {...field}
            value={field.value}
            onChange={(event) => {
              const value = event.target.value;
              handleChange(index, name, value);
              field.onChange(value); // react-hook-formのfield.onChangeも呼び出す
            }}
          >
            {options.map((option) => (
              <MenuItem key={option.value.toString()} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
    )}}
    />
  );
};

export default SelectField;
